import React from 'react';
import ProjectLayout from '../Components/ProjectLayout';

import listenGif from '../assets/projects/travelperk/Listen.gif';
import posterGif from '../assets/projects/travelperk/Poster.gif';
import chatSymbolGif from '../assets/projects/travelperk/ChatSymbol.gif';
import talentGif from '../assets/projects/travelperk/Talent.gif';
import walkingGif from '../assets/projects/travelperk/Walking.gif';

const Travelperk = () => {
  return (
    <ProjectLayout
      title="TravelPerk"
      description={[
        'TravelPerk teamed up with me to bring their new brand to life through sleek motion graphics.',
        'Designed for internal events and summits, these animations helped unite teams around a bold, refreshed identity.',
      ]}
      credits={['Motion Graphics', 'Brand Animation']}
    >
      <div className="pm-video">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster="/images/travelperk-summit-poster.webp"
        >
          <source src="/videos/travelperk-summit.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="pm-row">
        <img src={listenGif} alt="Listen" style={{ objectPosition: 'left' }} />
        <img src={posterGif} alt="Poster" />
      </div>

      <img className="pm-full" src={chatSymbolGif} alt="Chat Symbol" />

      <div className="pm-row">
        <img src={walkingGif} alt="Walking" />
        <img src={talentGif} alt="Talent" />
      </div>
    </ProjectLayout>
  );
};

export default Travelperk;
